export default "__VITE_ASSET__DmI65hkc__"